<template>
  <v-row>
    <v-col
      cols="12"
    >
      <base-card>
        <v-card-text>
          <v-card-title>
            Lista de Usuarios
            <v-spacer />
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Buscar"
              single-line
              hide-details
            />
            <v-spacer />
          </v-card-title>
          <br>
          <v-data-table
            :headers="headers"
            :items="detailsUser"
            :search="search"
            class="elevation-1"
          >
            <template v-slot:[`item.created_at`]="{ item }">
              {{ formatDateTime(item.created_at) }}
            </template>
            <template v-slot:[`item.updated_at`]="{ item }">
              {{ formatDateTime(item.updated_at) }}
            </template>
            <template v-slot:[`item.estado`]="{ item }">
              <v-chip
                :color="isActive(item) ? 'green' : 'red'"
                small
                dark
              >
                {{ isActive(item) ? 'Activo' : 'Inactivo' }}
              </v-chip>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <div class="actions-cell">
                <v-icon
                  v-can="'Editar Usuario'"
                  style="cursor:pointer;"
                  color="primary"
                  title="Editar usuario"
                  @click="openEditDialog(item)"
                >
                  mdi-pencil
                </v-icon>
                <v-icon
                  v-can="'Editar Usuario'"
                  style="cursor:pointer;"
                  :color="isActive(item) ? 'orange' : 'green'"
                  :title="isActive(item) ? 'Inactivar usuario' : 'Activar usuario'"
                  @click="openStatusDialog(item)"
                >
                  {{ isActive(item) ? 'mdi-account-off' : 'mdi-account-check' }}
                </v-icon>
                <v-icon
                  v-can="'Editar Usuario'"
                  style="cursor:pointer;"
                  color="red"
                  title="Eliminar usuario"
                  @click="openDeleteDialog(item)"
                >
                  mdi-delete
                </v-icon>
              </div>
            </template>
          </v-data-table>
        </v-card-text>
      </base-card>
    </v-col>

    <!-- Diálogo de Edición de Usuario -->
    <edit-user-modal
      :show="showEditDialog"
      :user="selectedUser"
      @close="closeEditDialog"
      @updated="handleUserUpdated"
    />

    <!-- Diálogo de confirmación: Activar / Inactivar -->
    <v-dialog
      v-model="showStatusDialog"
      max-width="450"
      persistent
    >
      <v-card>
        <v-toolbar
          style="background-color:rgb(204 33 40);color:white !important"
          dark
        >
          <strong>{{ isActive(selectedUser) ? 'Inactivar Usuario' : 'Activar Usuario' }}</strong>
        </v-toolbar>
        <v-card-text style="padding-top: 20px;">
          ¿Está seguro que desea
          {{ isActive(selectedUser) ? 'inactivar' : 'activar' }}
          al usuario <strong>{{ selectedUser.name }}</strong>?
          <v-progress-linear
            v-if="processing"
            class="mt-4"
            color="red darken-4"
            indeterminate
            rounded
            height="6"
          />
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn
            text
            :disabled="processing"
            @click="closeStatusDialog"
          >
            Cancelar
          </v-btn>
          <v-btn
            text
            style="background-color:rgb(204 33 40);color:white !important"
            :disabled="processing"
            @click="confirmStatusChange"
          >
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo de confirmación: Eliminar -->
    <v-dialog
      v-model="showDeleteDialog"
      max-width="450"
      persistent
    >
      <v-card>
        <v-toolbar
          style="background-color:rgb(204 33 40);color:white !important"
          dark
        >
          <strong>Eliminar Usuario</strong>
        </v-toolbar>
        <v-card-text style="padding-top: 20px;">
          ¿Está seguro que desea eliminar al usuario
          <strong>{{ selectedUser.name }}</strong>?
          Esta acción no se puede deshacer.
          <v-progress-linear
            v-if="processing"
            class="mt-4"
            color="red darken-4"
            indeterminate
            rounded
            height="6"
          />
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn
            text
            :disabled="processing"
            @click="closeDeleteDialog"
          >
            Cancelar
          </v-btn>
          <v-btn
            text
            style="background-color:rgb(204 33 40);color:white !important"
            :disabled="processing"
            @click="confirmDelete"
          >
            Eliminar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snackbar"
      :color="snackbarColor"
      :timeout="3000"
    >
      {{ snackbarText }}
    </v-snackbar>
  </v-row>
</template>

<script>
  export default {
    name: 'ShowUsers',
    components: {
      EditUserModal: () => import('./EditUserModal'),
    },
    data () {
      return {
        search: '',
        showEditDialog: false,
        showStatusDialog: false,
        showDeleteDialog: false,
        processing: false,
        selectedUser: {},
        snackbar: false,
        snackbarText: '',
        snackbarColor: 'success',
        headers: [
          { text: 'Cliente', value: 'NombreCompania' },
          { text: 'Nombre', value: 'name' },
          { text: 'Correo', value: 'email' },
          { text: 'Roles', value: 'rol' },
          { text: 'Estado', value: 'estado', align: 'center' },
          { text: 'Fecha Creación   ', value: 'created_at' },
          { text: 'Fecha Actualización', value: 'updated_at' },
          { text: 'Acciones', value: 'actions', sortable: false, align: 'center', width: 130 },
        ],
      }
    },
    computed: {
      detailsUser () {
        return this.$store.state.users.listUsers.Mensaje
      },
    },
    created () {
      this.getListUsers()
    },
    methods: {
      formatDateTime (value) {
        if (!value) return '—'
        const str = String(value).replace('T', ' ')
        const [datePart, timePart = ''] = str.split(' ')
        const [y, m, d] = datePart.split('-')
        if (!y || !m || !d) return value
        const time = timePart.substring(0, 8)
        return `${d}/${m}/${y} ${time}`.trim()
      },
      isActive (item) {
        const estado = item && item.estado
        if (estado === undefined || estado === null || estado === '') {
          return true
        }
        return estado === 1 || estado === '1' || estado === true
      },
      async getListUsers () {
        await this.$store.dispatch('users/getListUsers')
      },
      showSnackbar (text, color = 'success') {
        this.snackbarText = text
        this.snackbarColor = color
        this.snackbar = true
      },
      openEditDialog (item) {
        this.selectedUser = item
        this.showEditDialog = true
      },
      closeEditDialog () {
        this.showEditDialog = false
        this.selectedUser = {}
      },
      async handleUserUpdated () {
        // Recargar la lista de usuarios cuando se actualiza exitosamente
        await this.getListUsers()
      },
      openStatusDialog (item) {
        this.selectedUser = item
        this.showStatusDialog = true
      },
      closeStatusDialog () {
        this.showStatusDialog = false
        this.selectedUser = {}
      },
      async confirmStatusChange () {
        this.processing = true
        const nuevoEstado = this.isActive(this.selectedUser) ? 0 : 1
        try {
          await this.$store.dispatch('users/updateStatusUser', {
            id: this.selectedUser.id,
            estado: nuevoEstado,
          })
          this.showStatusDialog = false
          this.showSnackbar(
            nuevoEstado === 1 ? 'Usuario activado exitosamente' : 'Usuario inactivado exitosamente',
          )
          await this.getListUsers()
        } catch (error) {
          this.showSnackbar(error.message || 'Error al cambiar el estado del usuario', 'error')
        } finally {
          this.processing = false
          this.selectedUser = {}
        }
      },
      openDeleteDialog (item) {
        this.selectedUser = item
        this.showDeleteDialog = true
      },
      closeDeleteDialog () {
        this.showDeleteDialog = false
        this.selectedUser = {}
      },
      async confirmDelete () {
        this.processing = true
        try {
          await this.$store.dispatch('users/deleteUser', {
            id: this.selectedUser.id,
          })
          this.showDeleteDialog = false
          this.showSnackbar('Usuario eliminado exitosamente')
          await this.getListUsers()
        } catch (error) {
          this.showSnackbar(error.message || 'Error al eliminar el usuario', 'error')
        } finally {
          this.processing = false
          this.selectedUser = {}
        }
      },
    },
  }
</script>

<style scoped>
.actions-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
  gap: 8px;
}

::v-deep .v-data-table__mobile-row .actions-cell {
  justify-content: flex-end;
}

::v-deep .v-data-table__mobile-row {
  min-height: 40px;
}
</style>
